import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
declare var $: any; // TODO show modal in othe way
import * as moment from 'moment';
import { environment } from "@environments/environment";

// Interfaces
import { UserInterface, ResponseDataBase } from '@interfaces/index.interface';

// Services
import {
  UserService,
  ResourceService,
  AuthService,
  CalendarLanguagueService
} from "@services/index.service";

//Constants
import { AppConstants } from '@app/appConstants';

/** Página de registro */
@Component({
  selector: 'app-register',
  templateUrl: './register.page.html'
})
export class RegisterComponent {

  optionalFields = environment.OPTIONAL_FIELDS_FOR_REGISTER;
  environmentName = environment.envName;
  hasCaptcha = environment.HASCAPTCHA;
  registerOnlyWithPin = environment.REGISTER_ONLY_WITH_PIN;
  pinHaveMail;
  maxDate = new Date();
  /** Alertas */
  alertDanger: string;
  alertWarning: string;
  alertSuccess: string;
  captchaResolved: boolean = false;
  /** Pin proporcionado por el SAP del propietario */
  pin;
  date: { year: number, month: number };
  minDate = { year: 1900, month: 1, day: 1 };
  forma: FormGroup;
  showAskForPin: boolean = false;
  applyForPin: any = {};
  showTypetForm;
  /** Datos del usuario a registrar. Lo iniciamos vacio y si hay PIN lo modificamos */
  user: UserInterface = {
    name: '',
    lastname: '',
    secondSurname: '',
    birthname: '',
    email: '',
    phoneNumber: '',
    language: '',
    gender: '',
    address: '',
    city: '',
    postalCode: '',
    country: '',
    birthDate: '',
    patnr: '',
    docType: '',
    docNumber: ''
  };

  constructor(public _userService: UserService,
    public _resourceService: ResourceService,
    public _authService: AuthService,
    public translate: TranslateService,
    public router: Router,
    public locale: CalendarLanguagueService) {
    /** Al iniciar la página configuramos el formulario con sus validadores */
    this.forma = new FormGroup({
      'name': new FormControl(),
      'lastname': new FormControl(),
      'secondSurname': new FormControl(),
      'birthname': new FormControl(),
      'email': new FormControl(),
      'confirmMail': new FormControl(),
      'password': new FormControl(),
      'confirmpassword': new FormControl(),
      'phoneNumber': new FormControl(),
      'language': new FormControl(),
      'gender': new FormControl(),
      'address': new FormControl(),
      'city': new FormControl(),
      'postalCode': new FormControl(),
      'country': new FormControl(),
      'birthDate': new FormControl(),
      'docNumber': new FormControl(),
      'docType': new FormControl(),
      'socialSecurityNumber': new FormControl(),
    });

    this.forma.value.birthDate = new Date();

    this.forma.controls['confirmpassword'].setValidators([
      Validators.required,
      this.notEqualPassword.bind(this.forma)
    ]);

    this.forma.controls['confirmMail'].setValidators([
      Validators.required,
      this.notEqualMail.bind(this.forma)
    ])

  }

  /** Comprueba si son iguales las contraseñas del formulario */
  notEqualPassword(control: FormControl): { [s: string]: boolean } {
    let forma: any = this;
    if (control.value !== forma.controls['password'].value) {
      return {
        notequalspass: true
      };
    }
    return null;
  }

  /** Comprueba si son iguales los mails del formulario */
  notEqualMail(control: FormControl): { [s: string]: boolean } {
    let forma: any = this;
    if (control.value !== forma.controls['email'].value) {
      return {
        notEqualsMail: true
      };
    }
    return null;
  }

  /** Comprobamos que en el formulario tenemos toda la información que necesitamos. */
  validateForm() {
    console.log('afdas',);
    this.deleteAlerts();
    this._userService.clearAlerts();
    // let data = this.forma.getRawValue();
    let data = this.forma.value;
    if (data.email != data.confirmMail) {
      this.alertDanger = "THE_EMAILS_ARE_NOT_EQUAL";
    } else if (!data.password) {
      this.alertDanger = "PLEASE_FILL_THE_PASSWORDS";
    } else if (data.password != data.confirmpassword) {
      this.alertDanger = "THE_PASSWORDS_ARE_NOT_EQUAL";
    } else if (typeof (data.birthDate) == 'string' && moment(data.birthDate, "DD-MM-YYYY").format('YYYY-MM-DD') == 'Invalid date') {
      this.alertDanger = "PLEASE_SELECT_VALID_DATE_CAN_USE_CALENDAR";
    } else if (!data.name || !data.lastname
      || !data.address || !data.city || !data.postalCode || !data.country
      || !data.phoneNumber || !data.birthDate || !data.gender) {
      this.alertDanger = "PLEASE_FILL_FIELDS_MARKS_WITH";
    } else {
      if (environment.OPTIONAL_FIELDS_FOR_REGISTER.DOCNUMBER) {
        if (!data.docType) {
          this.alertDanger = "PLEASE_SELECT_DOC_TYPE";
        } /* else if (!this._resourceService.checkDni(data.docNumber)) {
          this.alertDanger = "PLEASE_FILL_DOC_NUMBER";
        } */ else if (!data.docNumber) {
          this.alertDanger = "PLEASE_FILL_DOC_NUMBER";
        } else if (!this._resourceService.validateEmail(data.email)) {
          this.alertDanger = "PLEASE_REVIEW_YOUR_EMAIL";
        } else {
          if (this._resourceService.validatePassword(data.password)) {
            this.registerUser();
          } else {
            this.alertDanger = "THE_PASSWORD_MUST_HAVE";
          }
        }
      } else {
        if (this._resourceService.validatePassword(data.password)) {
          this.registerUser();
        } else {
          this.alertDanger = "THE_PASSWORD_MUST_HAVE";
        }
      }
    }
    window.scrollTo(0, 0);
  }

  validateTypetForm() {
    this.deleteAlerts();
    let data = this.forma.value;
    if (!data.email) {
      this.alertDanger = "THE_EMAIL_MANDATORY";
    } else if (data.email != data.confirmMail) {
      this.alertDanger = "THE_EMAILS_ARE_NOT_EQUAL";
    } else if (!data.password) {
      this.alertDanger = "PLEASE_FILL_THE_PASSWORDS";
    } else if (data.password != data.confirmpassword) {
      this.alertDanger = "THE_PASSWORDS_ARE_NOT_EQUAL";
    } else {
      if (this._resourceService.validateTypetPasswordwithUserName(data.password, data.email)) {
        this.registerUser();
      } else {
        this.alertDanger = "THE_PASSWORD_MUST_HAVE";
      }
    }
    window.scrollTo(0, 0);
  }

  /** Mandamos al back la información del formulario para crear un nuevo usuario. Si el back responde correctamente le decimos
   * que le hemos enviado un correo, sino mostramos el error en una alerta
   */
  registerUser() {
    this.deleteAlerts();
    let birthDate;
    if (typeof (this.forma.value.birthDate) == 'string') {
      birthDate = moment(this.forma.value.birthDate, "DD-MM-YYYY").format('YYYY-MM-DD');
    } else {
      this.forma.value.birthDate.month--;
      birthDate = moment(this.forma.value.birthDate).format('YYYY-MM-DD');
    }
    let params: any = {
      email: this.forma.value.email,
      password: this.forma.value.password,
      name: this.forma.value.name,
      lastname: this.forma.value.lastname,
      birthDate: birthDate,
      phoneNumber: this.forma.value.phoneNumber,
      address: this.forma.value.address,
      city: this.forma.value.city,
      postalCode: this.forma.value.postalCode,
      country: this.forma.value.country,
      patnr: this.user.patnr,
      socialSecurityNumber: this.forma.value.socialSecurityNumber,
      pin: this.pin
    };
    if (environment.OPTIONAL_FIELDS_FOR_REGISTER.SECOND_SURNAME && this.forma.value.birthname) {
      params.secondSurname = this.forma.value.birthname;
    }
    if (environment.OPTIONAL_FIELDS_FOR_REGISTER.LANGUAGE && this.forma.value.language) {
      params.language = this.forma.value.language;
    } else {
      params.language = environment.DEFAULTLANGUAGE;
    }
    if (environment.OPTIONAL_FIELDS_FOR_REGISTER.GENDER && this.forma.value.gender) {
      params.gender = this.forma.value.gender;
    }
    if (environment.OPTIONAL_FIELDS_FOR_REGISTER.DOCNUMBER) {
      params.docType = this.forma.value.docType;
      params.docNumber = this.forma.value.docNumber;
    }
    this._userService.registerUser(params).subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
        if (this.registerOnlyWithPin) {
          delete this._authService.alert;
          this._userService.warning = 'YOU_CAN_LOGIN';
        } else {
          this._userService.warning = 'MAIL_HAVE_BEEN_SENT';
        }
        $('#LoginModal').modal('show');
        window.scrollTo(0, 0);
      } else {
        this.alertDanger = response.METADATA.ERROR_MESSAGE;

        window.scrollTo(0, 0);
        // document.getElementById("openModalButton").click();
      }
      this._userService.loading = false;
      this._resourceService.loading = false;
    });

  }

  /** Reseteamos el formulario con los datos del usuario, que son, o bien vacios como el usuario que hemos declarado  */
  resetRegisterForm() {
    this.forma.reset(this.user);
  }

  /** Si el usuario rellena el modal del pin lo recuperamos y lo mandamos como parámetos al back. Si nos contesta ok, sacamos los datos
   * del usuario. Si no, mostramos el error en una lerta.
   */
  sendPin() {
    this.deleteAlerts();
    this._userService.loading = true;
    let params = {
      pinuser: this.pin
    };
    this._userService.getpatientpin(params).subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
        $('#PinModal').modal('hide');
        /*         if (response.result[0].email) {
                  this.pinHaveMail = true;
                  this.forma.get('email').disable();
                } */
        this.user = response.result[0];
        this.user.birthDate = this.user.birthDate.split("-").reverse().join("-");
        /*         this.user.birthDate = {
              day: moment(this.user.birthDate).toObject().date,
              month: moment(this.user.birthDate).toObject().months + 1,
              year: moment(this.user.birthDate).toObject().years,
            }; */
        /* for (const property in this.user) {
          if (this.forma.get(property) && this.user[property]) {
            this.forma.get(property).disable();
          }
        } */
        this.forma.get('password').enable();
        this.forma.get('confirmpassword').enable();
        this.forma.get('confirmMail').enable();
        /* if (!this.user.email) {
          this.forma.get('email').enable();
        } */
      } else {
        this.alertDanger = response.METADATA.ERROR_MESSAGE;
        window.scrollTo(0, 0);
        delete this.pin;
      }
      this._userService.loading = false;
    });
  }

  ApplyForPin() {
    this.deleteAlerts();
    if (!this._resourceService.validateEmail(this.applyForPin.email)) {
      this.alertDanger = 'PLEASE_REVIEW_YOUR_EMAIL';
    } else {
      if (this.checkApplyForPinTerms()) {
        this.applyForPin.date = moment().format('YYYY-MM-DD');
        this._resourceService.applyforpin(this.applyForPin).subscribe(data => {
          let response = data as ResponseDataBase;
          if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
            this.alertSuccess = 'CHECK_MAIL';
          } else {
            this.alertDanger = response.METADATA.ERROR_MESSAGE;
            window.scrollTo(0, 0);
          }
          this._resourceService.loading = false;
          this._userService.loading = false;
          this.showAskForPin = false;
          $('#PinModal').modal('hide');
        });
      } else {
        this._resourceService.loading = false;
        this._userService.loading = false;
        this.alertDanger = 'PLEASE_FILL_FIELDS_MARKS_WITH';
      }
    }
  }

  resolved(captchaResponse: string) {
    this.captchaResolved = true;
  }

  checkApplyForPinTerms() {
    if (!this.applyForPin.name || !this.applyForPin.lastname || !this.applyForPin.email
      || !this.applyForPin.address || !this.applyForPin.city) {
      return false;
    } else {
      return true;
    }
  }

  deleteAlerts() {
    delete this.alertDanger;
    delete this.alertWarning;
    delete this.alertSuccess;
  }

  ngOnInit() {
    /** Eliminamos la alertas y mostramos el Modal del pin */
    this.deleteAlerts();
    $('#PinModal').modal('show');
  }

}
